import { useAutoUpdatingRef } from '@quickmd-llc/frontend-utils'
import { useSelector } from 'store/hooks/useSelector'
import { type Visit } from 'types/types'

export function useVisitCallEventDataRef(visit: Partial<Visit>) {
  const patientInfo = useSelector((state) => state.waitingRoomReducer.currentPatientInfo)
  const providerEmail = useSelector((state) => state.waitingRoomReducer.providerProfile.Email)

  return useAutoUpdatingRef({
    patient: patientInfo,
    providerEmail,
    visit,
  })
}
